// // import { useForm } from "react-hook-form";
// // import { useNavigate, Link } from "react-router-dom";
// // import toast from "react-hot-toast";
// // import authService from "../../services/authService";
// // import styles from "./Forgot.module.css";
// // export default function ForgotPassword() {
// //     const navigate = useNavigate();
// //     const {
// //         register,
// //         handleSubmit,
// //         formState: { errors },
// //     } = useForm();
// //     const onSubmit = async (data) => {
// //         try {
// //             await authService.requestPasswordResetOtp(data.login);
// //             toast.success("Password reset OTP sent successfully");
// //             navigate("/reset-password", {
// //                 state: { login: data.login },
// //             });
// //         } catch (err) {
// //             toast.error(
// //                 err?.response?.data?.message || "Failed to send OTP"
// //             );
// //         }
// //     };
// //     return (
// //         <div className={styles.authWrapper}>
// //             <div className={styles.card}>

// //                 {/* LOGO */}
// //                 <div className={styles.logo}>
// //                     <Link to="/" className="app-brand-link gap-2">
// //                         <img src="/Fashion_logo.svg" alt="Logo" />
// //                     </Link>
// //                 </div>
// //                 <h4 className={styles.title}>Forgot Password 🔐</h4>

// //                 <form onSubmit={handleSubmit(onSubmit)}>
// //                     <div className={styles.formGroup}>
// //                         <label>Enter Email or Phone Number :</label>
// //                         <input
// //                             type="text"
// //                             placeholder="Email or phone number"
// //                             {...register("login", {
// //                                 required: "This field is required",
// //                             })}
// //                         />
// //                         {errors.login && (
// //                             <span className={styles.error}>
// //                                 {errors.login.message}
// //                             </span>
// //                         )}
// //                     </div>

// //                     <button type="submit" className={styles.primaryBtn}>
// //                         Send OTP
// //                     </button>
// //                 </form>
// //                 <div className="d-flex justify-content-center mt-3">
// //                     Remembered your password ? <Link to="/login">
// //                         <large className="ml-3"> Login</large>
// //                     </Link>
// //                 </div>

// //             </div>
// //         </div>
// //     );
// // }

// import { useForm } from "react-hook-form";
// import { useNavigate, Link } from "react-router-dom";
// import toast from "react-hot-toast";
// import authService from "../../services/authService";
// import styles from "./Forgot.module.css";
// import { useState } from "react";
// export default function ForgotPassword() {
//     const navigate = useNavigate();
//     const [loading, setLoading] = useState(false);
//     const {
//         register,
//         handleSubmit,
//         formState: { errors },
//     } = useForm();
//  const onSubmit = async (data) => {
//     setLoading(true);
//     try {
//         await authService.requestPasswordResetOtp(data.login);
//         toast.success("Password reset OTP sent successfully");
//         navigate("/reset-password", {
//             state: { login: data.login },
//         });
//     } catch (err) {
//         toast.error(
//             err?.response?.data?.message || "Failed to send OTP"
//         );
//     } finally {
//         setLoading(false);
//     }
// };
//     return (
//         <div className={styles.authWrapper}>
//             <div className={styles.card}>

//                 {/* LOGO */}
//                 <div className={styles.logo}>
//                     <Link to="/" className="app-brand-link gap-2">
//                         <img src="/Fashion_logo.svg" alt="Logo" />
//                     </Link>
//                 </div>
//                 <h4 className={styles.title}>Forgot Password 🔐</h4>

//                 <form onSubmit={handleSubmit(onSubmit)}>
//                     <div className={styles.formGroup}>
//                         <label>Enter Email or Phone Number :</label>
//                         <input
//                             type="text"
//                             placeholder="Email or phone number"
//                             {...register("login", {
//                                 required: "This field is required",
//                             })}
//                         />
//                         {errors.login && (
//                             <span className={styles.error}>
//                                 {errors.login.message}
//                             </span>
//                         )}
//                     </div>

//                     <button type="submit" className={styles.primaryBtn} disabled={loading}>
//     {loading ? "Sending..." : "Send OTP"}
// </button>
//                 </form>
//                 <div className="d-flex justify-content-center mt-3"  style={{color:"#536c8a"}}>
//                     Remembered your password ? <Link to="/login">
//                         <large className="ml-3" style={{color:"#143962"}}> Login</large>
//                     </Link>
//                 </div>

//             </div>
//         </div>
//     );
// }


// import { useForm } from "react-hook-form";
// import { useNavigate, Link } from "react-router-dom";
// import toast from "react-hot-toast";
// import authService from "../../services/authService";
// import styles from "./Forgot.module.css";
// export default function ForgotPassword() {
//     const navigate = useNavigate();
//     const {
//         register,
//         handleSubmit,
//         formState: { errors },
//     } = useForm();
//     const onSubmit = async (data) => {
//         try {
//             await authService.requestPasswordResetOtp(data.login);
//             toast.success("Password reset OTP sent successfully");
//             navigate("/reset-password", {
//                 state: { login: data.login },
//             });
//         } catch (err) {
//             toast.error(
//                 err?.response?.data?.message || "Failed to send OTP"
//             );
//         }
//     };
//     return (
//         <div className={styles.authWrapper}>
//             <div className={styles.card}>

//                 {/* LOGO */}
//                 <div className={styles.logo}>
//                     <Link to="/" className="app-brand-link gap-2">
//                         <img src="/Anuradha_logo_1.svg" alt="Logo" />
//                     </Link>
//                 </div>
//                 <h4 className={styles.title}>Forgot Password 🔐</h4>

//                 <form onSubmit={handleSubmit(onSubmit)}>
//                     <div className={styles.formGroup}>
//                         <label>Enter Email or Phone Number :</label>
//                         <input
//                             type="text"
//                             placeholder="Email or phone number"
//                             {...register("login", {
//                                 required: "This field is required",
//                             })}
//                         />
//                         {errors.login && (
//                             <span className={styles.error}>
//                                 {errors.login.message}
//                             </span>
//                         )}
//                     </div>

//                     <button type="submit" className={styles.primaryBtn}>
//                         Send OTP
//                     </button>
//                 </form>
//                 <div className="d-flex justify-content-center mt-3">
//                     Remembered your password ? <Link to="/login">
//                         <large className="ml-3"> Login</large>
//                     </Link>
//                 </div>

//             </div>
//         </div>
//     );
// }

import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../../services/authService";
import styles from "./Forgot.module.css";
import { useState } from "react";
import { validateEmail, validateMobile } from "../../utils/Validations";
export default function ForgotPassword() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
   } = useForm({
    mode: "onBlur",
});
 const onSubmit = async (data) => {
    setLoading(true);
    try {
        await authService.requestPasswordResetOtp(data.login);
        toast.success("Password reset OTP sent successfully");
        navigate("/reset-password", {
            state: { login: data.login },
        });
    } catch (err) {
        toast.error(
            err?.response?.data?.message || "Failed to send OTP"
        );
    } finally {
        setLoading(false);
    }
};
    return (
        <div className={styles.authWrapper}>
            <div className={styles.card}>

                {/* LOGO */}
                <div className={styles.logo}>
                    <Link to="/" className="app-brand-link gap-2">
                            <img src="/Fashion_logo.svg" alt="Logo" />
                    </Link>
                </div>
                <h4 className={styles.title}>Forgot Password 🔐</h4>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={styles.formGroup}>
                        <label>Enter Email or Phone Number :</label>
                        <input
                            type="text"
                            placeholder="Email or phone number"
                           {...register("login", {
    required: "Email or phone number is required",

    validate: (value) => {
        const input = value?.trim() || "";

        const emailResult = validateEmail(input);
        const mobileResult = validateMobile(input);

        if (
            emailResult === true ||
            mobileResult === true
        ) {
            return true;
        }

        return "Please enter a valid email address or mobile number";
    },
})}
                        />
                        {errors.login && (
                            <span className={styles.error}>
                                {errors.login.message}
                            </span>
                        )}
                    </div>

                    <button type="submit" className={styles.primaryBtn} disabled={loading}>
    {loading ? "Sending..." : "Send OTP"}
</button>
                </form>
                <div className="d-flex justify-content-center mt-3"  style={{color:"#214b7a"}}>
                    Remembered your password ? <Link to="/login">
                        <large className="ml-3" style={{color:"#214b7a"}}> Login</large>
                    </Link>
                </div>

            </div>
        </div>
    );
}